import { LightbulbOutlineIcon } from './LightbulbOutlineIcon';

/**
 * author: Austin Andrews
 * id BF6C3B65-0795-43E0-B373-058414FDD485
 * name lightbulb-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-outline.svg
 * tags
 * - Home Automation 
 */
export const BulbOutlineIcon = LightbulbOutlineIcon;
export default BulbOutlineIcon